export enum FeatureFlag {
    PickupFulfillment = 'PICKUP_FULFILLMENT',
    MyAppointments = 'MY_APPOINTMENTS',
}
